export const PINCHE_INCOMPLETE_MESSAGES = {
  ingredients:
    "He podido recuperar parte de la receta, pero me faltan algunos ingredientes o cantidades para completarla. Añádelos y sigo desde ahí.",
  procedure:
    "Ya tengo los ingredientes y cantidades. Solo me faltan algunos pasos del procedimiento. Añádelos y sigo desde ahí.",
  general:
    "He podido recuperar parte de la receta, pero me faltan algunos datos para completarla. Añade lo que falte y sigo desde ahí.",
};

export const getPincheIncompleteMessage = (code, pipeline = {}, fallback = "") => {
  const audioDone = pipeline.audio_downloaded === true;
  const transcriptDone = pipeline.transcript_available === true;
  const ingredientsMissing = pipeline.ingredients_sufficient === false;
  const procedureMissing = pipeline.procedure_sufficient === false;
  if (ingredientsMissing && !procedureMissing && audioDone && transcriptDone) {
    return "Ya he analizado el Reel y su audio, pero la información disponible no contiene suficientes ingredientes y cantidades para completar la receta con fiabilidad. Si el creador ha publicado la receta en la descripción o en un comentario fijado, pégala aquí y continuaré con lo que ya tengo.";
  }
  if (!ingredientsMissing && procedureMissing && transcriptDone) {
    return "Ya tengo los ingredientes y cantidades y he revisado la transcripción disponible. Solo me faltan algunos pasos claros del procedimiento. Añádelos y sigo desde ahí.";
  }
  if (ingredientsMissing && procedureMissing && audioDone && transcriptDone) {
    return "Ya he analizado el Reel y su audio, pero la información disponible no contiene suficientes ingredientes y cantidades ni todos los pasos para completar la receta con fiabilidad. Si el creador ha publicado la receta o el procedimiento en la descripción o en un comentario fijado, pégalo aquí y continuaré con lo que ya tengo.";
  }
  if (code?.endsWith("ingredients_required")) return PINCHE_INCOMPLETE_MESSAGES.ingredients;
  if (code?.endsWith("procedure_required")) return PINCHE_INCOMPLETE_MESSAGES.procedure;
  if (code?.endsWith("more_info_required")) return PINCHE_INCOMPLETE_MESSAGES.general;
  return fallback || PINCHE_INCOMPLETE_MESSAGES.general;
};